import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import DasboardView from '../views/DashboardView.vue'
import TeamView from '../views/TeamView.vue'
import AppointmentView from '../views/AppointmentView.vue'
import RegistrationView from '../views/RegistrationView.vue'
import EncounterView from '../views/EncounterView.vue'
import RecordView from '../views/RecordView.vue'
import ManagementView from '../views/ManagementView.vue'
import PatientDetail from '../components/patientDetail/PatientDetail.vue'
import LoginPage from '../components/LoginPage.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/registration',
    name: 'registration',
    component: RegistrationView
  },
  {
    path: '/appointments',
    name: 'appointments',
    component: AppointmentView
  },
  {
    path: '/encounters',
    name: 'encounters',
    component: EncounterView
  },
  {
    path: '/records',
    name: 'records',
    component: RecordView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: TeamView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DasboardView
  },
  {
    path: '/management',
    name: 'management',
    component: ManagementView
  },
  {
    path: '/patient-detail',
    name: 'patient-detail',
    component: PatientDetail
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      hideNavbar: true,
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
